lmApp.service('FavouritesResource', ['$resource', function ($resource) {
    return $resource('/discovery:80/collection/subscriber.favorites.asset/query',
        null,
        {
            get: {
                url: '/discovery:80/collection/subscriber.favorites.asset/query',
                headers: {
                    'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
                }
            }
        });
}]);
